import { PromotionCodeState } from "../Enum/PromoCode";

export class PromotionCodeRequest {
  PromotionCode: string;
}

export class PromotionCodeResponse {
  PromotionCodeState: PromotionCodeState = null;
}
